import cn from 'client/utils/cn';

import React, { Component } from 'react';

import TextNoData from 'client/components/text-no-data';

import { BunkerNotFound } from 'client/bundles/types';

const b = cn('not-found');
const bPageTitle = cn('page-title');

interface Props {
    notFound: BunkerNotFound;
}

class NotFound extends Component<Props> {
    render() {
        const { notFound: { title, text } } = this.props;

        return (
            <div className={b('')}>
                <h1 className={bPageTitle()}>{title}</h1>

                <TextNoData text={text} />
            </div>
        );
    }
}

export default NotFound;
